var map = {
	"./point_1.png": "b9ed",
	"./point_10.png": "b85d",
	"./point_11.png": "bf6b",
	"./point_12.png": "3915",
	"./point_13.png": "a90b",
	"./point_14.png": "c21c",
	"./point_15.png": "32da",
	"./point_16.png": "3f36",
	"./point_17.png": "4f66",
	"./point_18.png": "4a88",
	"./point_19.png": "d010",
	"./point_2.png": "666d",
	"./point_20.png": "df7b",
	"./point_21.png": "c10d",
	"./point_22.png": "177b",
	"./point_23.png": "8c71",
	"./point_24.png": "e22d",
	"./point_25.png": "d797",
	"./point_26.png": "ac70",
	"./point_27.png": "1935",
	"./point_28.png": "2aa9",
	"./point_29.png": "5919",
	"./point_3.png": "cb1d",
	"./point_30.png": "de37",
	"./point_31.png": "4a52",
	"./point_32.png": "9144",
	"./point_33.png": "a385",
	"./point_34.png": "2826",
	"./point_35.png": "f6f7",
	"./point_36.png": "fe0e",
	"./point_37.png": "4171",
	"./point_38.png": "6b91",
	"./point_39.png": "3b37",
	"./point_4.png": "7c4e",
	"./point_40.png": "0484",
	"./point_41.png": "f325",
	"./point_42.png": "ebae",
	"./point_43.png": "3ed8",
	"./point_44.png": "c3c9",
	"./point_45.png": "d771",
	"./point_46.png": "74da",
	"./point_47.png": "2df1",
	"./point_48.png": "25c0",
	"./point_49.png": "f661",
	"./point_5.png": "85e5",
	"./point_50.png": "c658",
	"./point_51.png": "6ed1",
	"./point_52.png": "38b6",
	"./point_53.png": "b4a0",
	"./point_54.png": "9456",
	"./point_55.png": "1072",
	"./point_56.png": "5b95",
	"./point_57.png": "3654",
	"./point_58.png": "769a",
	"./point_59.png": "f26b",
	"./point_6.png": "078a",
	"./point_60.png": "3934",
	"./point_7.png": "7130",
	"./point_8.png": "a4af",
	"./point_9.png": "e91e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "388b";